import { fallbackTableContent, RowType } from '@getaccept/editor-lib-new';
import { defineComponent, computed } from 'vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
import ProsemirrorViewerTable from './ProsemirrorViewerTable.vue';
export default defineComponent({
    name: 'EditorNodeTable',
    components: {
        ProsemirrorViewerTable,
        EditorNodeWrapper,
    },
    props: {
        node: { type: Object, default: () => ({}) },
        mergeValues: { type: Object, required: true },
        isPdfViewer: { type: Boolean, default: false },
        rowType: { type: String, default: () => RowType.Standard },
        blockWidthClass: {
            type: String,
            default: null,
        },
    },
    emits: ['observe-node-visibility'],
    setup(props) {
        const fields = computed(() => props.node.fields || []);
        const jsonContent = computed(() => {
            const tableContent = props.node.content || fallbackTableContent;
            return JSON.parse(tableContent);
        });
        const borderColor = computed(() => { var _a; return (_a = props.node.tableStyle) === null || _a === void 0 ? void 0 : _a.borderColor; });
        const alternateRowColor = computed(() => { var _a; return (_a = props.node.tableStyle) === null || _a === void 0 ? void 0 : _a.alternateRowColor; });
        const headerRowBackgroundColor = computed(() => { var _a; return (_a = props.node.tableStyle) === null || _a === void 0 ? void 0 : _a.headerRowBackgroundColor; });
        const rowTypeClass = computed(() => { var _a; return `row-type-${(_a = props.rowType) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`; });
        return {
            fields,
            jsonContent,
            borderColor,
            alternateRowColor,
            headerRowBackgroundColor,
            rowTypeClass,
        };
    },
});
